<div *ngIf="sectionName" class="section-name">{{sectionName}}</div>

<div class="toolbar">
    <p-toolbar styleClass="section-toolbar">
        <div class="p-toolbar-group-left">
            <ng-container *ngIf="!hideSearchAndFilter && filterItems && filterItems.length > 0">
                <p-menu #filterMenu [popup]="true" [model]="filterItems" [styleClass]="'filter-menu' + (filterMenuWide ? ' wide' : '')" ></p-menu>
                <button type="button" pButton class="filter-button" (click)="filterMenu.toggle($event)">
                    <fa-icon icon="arrow-down-wide-short" size="1x"></fa-icon>
                    <span class="filter-label">{{filterLabel}}</span>
                </button>
            </ng-container>

            <span *ngIf="!hideSearchAndFilter && searchTextChange.observed" class="p-input-icon-left">
                <i *ngIf="!deviceManager.isMobile" class="pi pi-search"></i>
                <input #search type="search" pInputText class="p-inputtext-sm" [placeholder]="searchPlaceholder" [(ngModel)]="searchText" (ngModelChange)="onSearchTextChanged()" />
            </span>

            <button *ngIf="addButtonClicked.observed" pButton pRipple type="button" class="p-button-rounded" icon="pi pi-fw pi-plus" [disabled]="addButtonDisabled"
                    [label]="deviceManager.isMobile ? '' : itemName" (click)="onAddButtonClicked()"></button>

            <button *ngIf="extraButtonClicked.observed" pButton pRipple type="button" class="p-button-rounded" [icon]="extraButtonIcon"
                    [label]="extraButtonText" (click)="onExtraButtonClicked()"></button>

            <div *ngIf="dateRangeChange.observed" class="date-area">
                <p-calendar #calendar styleClass="date-range-calendar" selectionMode="range" hourFormat="12" [(ngModel)]="dateRangeForCalendarInput" appendTo="body"
                            (onInput)="onDateInput()" (onSelect)="onDateSelected()" [hideOnDateTimeSelect]="true"></p-calendar>
            </div>

            <button *ngIf="goButtonClicked.observed" pButton pRipple type="button" class="p-button-rounded" [disabled]="goButtonDisabled"
                    (click)="onGoButtonClicked()">Go</button>
        </div>

        <div *ngIf="extraToolbarComponents" class="extra-toolbar-container">
            <ng-container [ngTemplateOutlet]="extraToolbarComponents"></ng-container>
        </div>
    </p-toolbar>
</div>
